import { render, staticRenderFns } from "./SettingsSupport.vue?vue&type=template&id=0f15bbe6"
import script from "./SettingsSupport.vue?vue&type=script&lang=ts"
export * from "./SettingsSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports